import { render, staticRenderFns } from "./sales_chart.vue?vue&type=template&id=f93b981a&scoped=true"
import script from "./sales_chart.vue?vue&type=script&lang=js"
export * from "./sales_chart.vue?vue&type=script&lang=js"
import style0 from "./sales_chart.vue?vue&type=style&index=0&id=f93b981a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93b981a",
  null
  
)

export default component.exports